var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-audio",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("audio", {
                    ref: "audio",
                    staticClass: "cw-audio-player",
                    attrs: {
                      src: _vm.currentURL,
                    },
                    on: {
                      timeupdate: _vm.onTimeUpdateListener,
                      durationchange: _vm.setDuration,
                      ended: _vm.onEndedListener,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cw-audio-container",
                    },
                    [
                      !_vm.userRecorderEnabled
                        ? _c(
                            "div",
                            {
                              staticClass: "cw-audio-player",
                              class: {
                                "with-playlist": _vm.playlistEnabled,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-audio-cover",
                                  class: {
                                    loading: _vm.loadingCover,
                                    "with-edit-button": _vm.canEditFile,
                                  },
                                },
                                [
                                  _vm.cover
                                    ? _c("img", {
                                        staticClass: "cover",
                                        attrs: {
                                          src: _vm.cover,
                                        },
                                      })
                                    : _c("studip-icon", {
                                        staticClass: "default-cover",
                                        attrs: {
                                          shape: _vm.emptyAudio
                                            ? "file"
                                            : "file-audio",
                                          size: 128,
                                          role: "info",
                                        },
                                      }),
                                  _vm._v(" "),
                                  _vm.canEditFile
                                    ? _c(
                                        "button",
                                        {
                                          attrs: {
                                            title: _vm.$gettext("Bearbeiten"),
                                          },
                                          on: {
                                            click: _vm.displayEditMP3,
                                          },
                                        },
                                        [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: "edit",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "cw-audio-controls-wrapper",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cw-audio-current-track",
                                    },
                                    [
                                      _c("h2", [
                                        _vm._v(_vm._s(_vm.trackTitle)),
                                      ]),
                                      _vm._v(" "),
                                      _c("h3", [
                                        _vm._v(_vm._s(_vm.trackArtist)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cw-audio-controls",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cw-audio-progress",
                                        },
                                        [
                                          !_vm.emptyAudio
                                            ? [
                                                _c("input", {
                                                  ref: "range",
                                                  staticClass: "cw-audio-range",
                                                  attrs: {
                                                    type: "range",
                                                    min: "0",
                                                    max: Math.round(
                                                      _vm.durationSeconds
                                                    ),
                                                  },
                                                  domProps: {
                                                    value: _vm.currentSeconds,
                                                  },
                                                  on: {
                                                    input: _vm.rangeAction,
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "cw-audio-time",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(_vm.currentTime)
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(_vm.durationTime)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            : _c("hr"),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cw-audio-buttons",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              attrs: {
                                                title: _vm.$gettext("Zurück"),
                                                disabled: !_vm.hasPlaylist,
                                              },
                                              on: {
                                                click: _vm.prevAudio,
                                              },
                                            },
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_eol-left",
                                                  role: _vm.hasPlaylist
                                                    ? "clickable"
                                                    : "inactive",
                                                  size: 24,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !_vm.playing
                                            ? _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    title:
                                                      _vm.$gettext("Abspielen"),
                                                    disabled: _vm.emptyAudio,
                                                  },
                                                  on: {
                                                    click: _vm.playAudio,
                                                  },
                                                },
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "play",
                                                      role: _vm.emptyAudio
                                                        ? "inactive"
                                                        : "clickable",
                                                      size: 48,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    title:
                                                      _vm.$gettext("Pause"),
                                                  },
                                                  on: {
                                                    click: _vm.pauseAudio,
                                                  },
                                                },
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "pause",
                                                      size: 48,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              attrs: {
                                                title: _vm.$gettext("Weiter"),
                                                disabled: !_vm.hasPlaylist,
                                              },
                                              on: {
                                                click: _vm.nextAudio,
                                              },
                                            },
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_eol-right",
                                                  role: _vm.hasPlaylist
                                                    ? "clickable"
                                                    : "inactive",
                                                  size: 24,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "cw-audio-recorder with-playlist",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-audio-cover",
                                },
                                [
                                  _c("studip-icon", {
                                    staticClass: "default-cover",
                                    attrs: {
                                      shape: "microphone",
                                      size: 128,
                                      role: _vm.isRecording
                                        ? "status-red"
                                        : "info",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "cw-audio-controls-wrapper",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cw-audio-current-track",
                                    },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          _vm._s(_vm.$gettext("Aufnahme"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.isRecording
                                        ? _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext("Aufnahme läuft")
                                              ) +
                                                ": " +
                                                _vm._s(
                                                  _vm.seconds2time(_vm.timer)
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.newRecording && !_vm.isRecording
                                        ? _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.seconds2time(_vm.timer)
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cw-audio-controls",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cw-recorder-visualization",
                                        },
                                        _vm._l(
                                          _vm.recorderFrequencyData,
                                          function (value, key) {
                                            return _c("div", {
                                              key: "bar" + key,
                                              ref: "bar" + key,
                                              refInFor: true,
                                              staticClass:
                                                "cw-recorder-visualization-bar",
                                              class: {
                                                "idle-bar": !_vm.isRecording,
                                              },
                                            })
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cw-audio-buttons",
                                        },
                                        [
                                          _vm.newRecording && !_vm.isRecording
                                            ? _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    title:
                                                      _vm.$gettext(
                                                        "Aufnahme löschen"
                                                      ),
                                                  },
                                                  on: {
                                                    click: _vm.resetRecorder,
                                                  },
                                                },
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "trash",
                                                      size: 24,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isRecording && !_vm.newRecording
                                            ? _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    title: _vm.$gettext(
                                                      "Neue Aufnahme starten"
                                                    ),
                                                  },
                                                  on: {
                                                    click: _vm.startRecording,
                                                  },
                                                },
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "span-full",
                                                      size: 48,
                                                      role: "status-red",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isRecording
                                            ? _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    title:
                                                      _vm.$gettext(
                                                        "Aufnahme beenden"
                                                      ),
                                                  },
                                                  on: {
                                                    click: _vm.stopRecording,
                                                  },
                                                },
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "stop",
                                                      size: 48,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.newRecording && !_vm.isRecording
                                            ? _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    title:
                                                      _vm.$gettext(
                                                        "Aufnahme speichern"
                                                      ),
                                                  },
                                                  on: {
                                                    click: _vm.storeRecording,
                                                  },
                                                },
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "download",
                                                      size: 48,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.newRecording && !_vm.isRecording
                                            ? _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    title: _vm.$gettext(
                                                      "Aufnahme wiederholen"
                                                    ),
                                                  },
                                                  on: {
                                                    click: _vm.startRecording,
                                                  },
                                                },
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "span-full",
                                                      size: 24,
                                                      role: "status-red",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.playlistEnabled,
                              expression: "playlistEnabled",
                            },
                          ],
                          staticClass: "cw-audio-playlist-wrapper",
                        },
                        [
                          _c(
                            "ul",
                            {
                              staticClass: "cw-audio-playlist",
                              class: [_vm.showRecorder ? "with-recorder" : ""],
                            },
                            [
                              _vm._l(_vm.files, function (file, index) {
                                return _c(
                                  "li",
                                  {
                                    key: file.id,
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "cw-playlist-item",
                                        attrs: {
                                          "aria-current":
                                            index === _vm.currentPlaylistItem
                                              ? "true"
                                              : "false",
                                          title:
                                            _vm.$gettext("Audiodatei:") +
                                            " " +
                                            file.name,
                                          href: "#",
                                        },
                                        on: {
                                          click: function click($event) {
                                            $event.preventDefault()
                                            return _vm.setCurrentPlaylistItem(
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("studip-icon", {
                                          attrs: {
                                            shape:
                                              index ===
                                                _vm.currentPlaylistItem &&
                                              !_vm.userRecorderEnabled
                                                ? _vm.playing
                                                  ? "pause"
                                                  : "play"
                                                : "file-audio2",
                                          },
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(file.name) +
                                            "\n                            "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.emptyAudio
                                ? _c("li", [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "cw-playlist-item",
                                      },
                                      [
                                        _c("studip-icon", {
                                          attrs: {
                                            shape: "file",
                                            role: "info",
                                          },
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Ordner enthält keine Audio-Dateien"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showRecorder && _vm.canGetMediaDevices
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-call-to-action",
                        },
                        [
                          !_vm.userRecorderEnabled
                            ? _c(
                                "button",
                                {
                                  staticClass: "action-button",
                                  attrs: {
                                    title: _vm.enableRecorderTitle,
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.enableRecorder.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "microphone",
                                      size: 48,
                                    },
                                  }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$gettext("Aufnahme aktivieren")
                                      ) +
                                      "\n                "
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "button",
                                {
                                  staticClass: "action-button",
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.resetRecorder.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "decline",
                                      size: 48,
                                    },
                                  }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$gettext("Aufnahme abbrechen")
                                      ) +
                                      "\n                "
                                  ),
                                ],
                                1
                              ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showEditMP3
                    ? _c("studip-dialog", {
                        attrs: {
                          title: _vm.$gettext("MP3 Metadaten bearbeiten"),
                          confirmText: _vm.$gettext("Speichern"),
                          confirmClass: "accept",
                          closeText: _vm.$gettext("Abbrechen"),
                          closeClass: "cancel",
                          height: "550",
                          width: "450",
                        },
                        on: {
                          close: _vm.closeEditMP3,
                          confirm: _vm.updateMP3,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "dialogContent",
                              fn: function fn() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit-mp3-cover-wrapper",
                                    },
                                    [
                                      _vm.newCoverUrl
                                        ? _c("img", {
                                            staticClass: "edit-mp3-cover",
                                            attrs: {
                                              src: _vm.newCoverUrl,
                                            },
                                          })
                                        : [
                                            _vm.cover && !_vm.deleteCover
                                              ? [
                                                  _c("img", {
                                                    staticClass:
                                                      "edit-mp3-cover",
                                                    attrs: {
                                                      src: _vm.cover,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _vm.cover
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "remove-cover",
                                                          attrs: {
                                                            title:
                                                              _vm.$gettext(
                                                                "Cover entfernen"
                                                              ),
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.removeCover,
                                                          },
                                                        },
                                                        [
                                                          _c("studip-icon", {
                                                            attrs: {
                                                              shape: "trash",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.cover === "" || _vm.deleteCover
                                              ? _c("studip-icon", {
                                                  staticClass:
                                                    "edit-mp3-cover default-cover",
                                                  attrs: {
                                                    shape: "file-audio",
                                                    size: 64,
                                                    role: "info",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "form",
                                    {
                                      staticClass: "default",
                                      on: {
                                        submit: function submit($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Cover")) +
                                              "\n                            "
                                          ),
                                          !_vm.deleteCover
                                            ? [
                                                _c("input", {
                                                  ref: "newCover",
                                                  staticClass: "cw-file-input",
                                                  attrs: {
                                                    type: "file",
                                                    accept: "image/jpeg",
                                                  },
                                                  on: {
                                                    change: _vm.updateCover,
                                                  },
                                                }),
                                              ]
                                            : _c("input", {
                                                attrs: {
                                                  type: "text",
                                                  disabled: "",
                                                  placeholder: _vm.$gettext(
                                                    "Cover wird entfernt"
                                                  ),
                                                },
                                              }),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$gettext("Titel")) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentMP3Title,
                                              expression: "currentMP3Title",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentMP3Title,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentMP3Title =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$gettext("Künstler")) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentMP3Artist,
                                              expression: "currentMP3Artist",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentMP3Artist,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentMP3Artist =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1609030996
                        ),
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Überschrift")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentTitle,
                                  expression: "currentTitle",
                                },
                              ],
                              attrs: {
                                type: "text",
                                placeholder: _vm.$gettext("optional"),
                              },
                              domProps: {
                                value: _vm.currentTitle,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentTitle = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Quelle")) +
                                "\n                    "
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentSource,
                                    expression: "currentSource",
                                  },
                                ],
                                on: {
                                  change: function change($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.currentSource = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "studip_file",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$gettext("Dateibereich Datei"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "studip_folder",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$gettext("Dateibereich Ordner")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "web",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Web-Adresse")))]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentSource === "web",
                                  expression: "currentSource === 'web'",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("URL")) +
                                  "\n                    "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentWebUrl,
                                    expression: "currentWebUrl",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentWebUrl,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) return
                                    _vm.currentWebUrl = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentSource === "studip_file",
                                  expression: "currentSource === 'studip_file'",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Datei")) +
                                  "\n                    "
                              ),
                              _c("studip-file-chooser", {
                                attrs: {
                                  selectable: "file",
                                  courseId: _vm.context.id,
                                  userId: _vm.userId,
                                  isAudio: true,
                                  excludedCourseFolderTypes:
                                    _vm.excludedCourseFolderTypes,
                                },
                                model: {
                                  value: _vm.currentFileId,
                                  callback: function callback($$v) {
                                    _vm.currentFileId = $$v
                                  },
                                  expression: "currentFileId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentSource === "studip_folder",
                                  expression:
                                    "currentSource === 'studip_folder'",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Ordner")) +
                                  "\n                    "
                              ),
                              _c("studip-file-chooser", {
                                attrs: {
                                  selectable: "folder",
                                  courseId: _vm.context.id,
                                  userId: _vm.userId,
                                  excludedCourseFolderTypes:
                                    _vm.excludedCourseFolderTypes,
                                },
                                model: {
                                  value: _vm.currentFolderId,
                                  callback: function callback($$v) {
                                    _vm.currentFolderId = $$v
                                  },
                                  expression: "currentFolderId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentSource === "studip_folder",
                                  expression:
                                    "currentSource === 'studip_folder'",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$gettext("Audio-Aufnahmen zulassen")
                                  ) +
                                  "\n                    "
                              ),
                              _c("span", {
                                staticClass: "tooltip tooltip-icon",
                                attrs: {
                                  "data-tooltip": _vm.$gettext(
                                    "Um Aufnahmen zu ermöglichen, muss ein Ordner ausgewählt werden. Der Safari-Browser unterstützt das genutze Audioformat nicht. Bitte verwenden Sie Firefox, Chrome oder einen ähnlichen Browser."
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentRecorderEnabled,
                                      expression: "currentRecorderEnabled",
                                    },
                                  ],
                                  attrs: {
                                    disabled: !_vm.folderSelected,
                                  },
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentRecorderEnabled = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: true,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: false,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum Audio-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }